/**
 * Results Templates
 * Template functions for product filters and search results
 */

(function(templates) {

  const translations = window.theme.tagalys.results.translations;
  const SIZE_FACET_ID = '_variant_size';

  /* ==========================================================================
     SVG Icons
     ========================================================================== */

  templates.chevronDownIcon = function() {
    return `
      <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.25713 4.57547L7.89349 0.939102C8.03551 0.797114 8.03551 0.566859 7.89347 0.424847C7.75146 0.282859 7.52123 0.282859 7.37922 0.424871L4.00006 3.80402L0.620668 0.424871C0.478656 0.282883 0.248426 0.282883 0.106414 0.424895C0.035408 0.495877 -8.29815e-05 0.588944 -8.29856e-05 0.68201C-8.29896e-05 0.775077 0.035408 0.868144 0.106439 0.93915L3.7428 4.57551C3.811 4.64373 3.90348 4.68203 3.99992 4.68203C4.09635 4.68203 4.18886 4.64373 4.25706 4.57551L4.25713 4.57547Z" fill="black"></path>
      </svg>
    `;
  };

  templates.checkmarkIcon = function() {
    return `
      <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_353_110)">
          <path d="M1.36377 3.18191L2.57589 4.31827L3.78801 5.45463L8.6365 0.90918" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
        <defs>
          <clipPath id="clip0_353_110">
            <rect width="10" height="6.36364" fill="#fff"></rect>
          </clipPath>
        </defs>
      </svg>
    `;
  };

  templates.closeIcon = function() {
    return `
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;
  };

  templates.closeIconLarge = function() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close" viewBox="0 0 14 14" width="20" height="20" aria-hidden="true" focusable="false" role="presentation" fill="none">
        <path d="M.693 1.4l11.749 11.749.707-.707L1.4.693z" fill="currentColor"></path>
        <path d="M12.442.693L.693 12.442l.707.707L13.149 1.4z" fill="currentColor"></path>
      </svg>
    `;
  };

  /* ==========================================================================
     Facet Item Templates
     ========================================================================== */

  templates.facetItemMobile = function(facet, value) {
    return `
      <li class="product-filters__facetItem">
        <label class="product-filters__facet" data-filter-search-el="facet" data-facet="${value.id}" data-label="${value.label}">
          <input type="checkbox" name="${facet.label}" value="${value.id}" ${value.selected ? 'checked' : ''} />
          <div class="product-filters__facetCustomIcon">
            ${templates.checkmarkIcon()}
          </div>
          <span>
            ${value.label} <span class="product-filters__count">(${value.count})</span>
          </span>
        </label>
      </li>
    `;
  };

  templates.facetItemDesktop = function(facet, value) {
    return `
      <li class="product-filters__facetItem">
        <label class="product-filters__facet">
          <input type="checkbox" name="${facet.label}" value="${value.id}" ${value.selected ? 'checked' : ''} />
          <div class="product-filters__facetCustomIcon">
            ${templates.checkmarkIcon()}
          </div>
          <span>
            ${value.label} <span class="product-filters__count">(${value.count})</span>
          </span>
        </label>
      </li>
    `;
  };

  /* ==========================================================================
     Filter Templates
     ========================================================================== */

  templates.mobileFilterDetails = function(facet, isOpen) {
    console.log('facet', facet)
    return `
      <details class="product-filters__details" ${isOpen ? 'open' : ''}>
        <summary class="product-filters__summary">
          <h3>${facet.id === SIZE_FACET_ID ? 'UK ' : ''}${facet.label}</h3>
          ${templates.chevronDownIcon()}
        </summary>

        <filter-search class="product-filters__facets">
          <input data-filter-search-el="search" class="product-filter__search" ${facet.id === SIZE_FACET_ID ? 'hidden' : ''} type="text" placeholder="${translations.searchPlaceholder}" aria-label="${translations.searchFiltersAriaLabel}" />
          <form data-product-filters-el="form" name="${facet.id}" data-form-type="filter">
            <ul class="product-filters__facetList">
              ${facet.items.map((value) => { return templates.facetItemMobile(facet, value); }).join('')}
            </ul>
          </form>
        </filter-search>
      </details>
    `;
  };

  templates.desktopFilterDropdown = function(facet, isExpanded) {
    return `
      <li class="product-filters-desktop__listitem">
        <button class="product-filters__trigger" data-product-filters-el="dropdown-trigger" ${isExpanded ? 'aria-expanded="true"' : 'aria-expanded="false"'} aria-haspopup="listbox" aria-controls="filterOptionDrawer${facet.id}" id="filter-${facet.label}">
          ${facet.id === SIZE_FACET_ID ? 'UK ' : ''}  
          ${facet.label}
          ${templates.chevronDownIcon()}
        </button>

        <div class="product-filters-desktop_dropdown" data-product-filters-el="dropdown" aria-labelledby="filter-${facet.label}" id="filterOptionDrawer${facet.id}">
          <form data-product-filters-el="form" name="${facet.id}" data-form-type="filter">
            <ul class="product-filters__facetList">
              ${facet.items.map((value) => { return templates.facetItemDesktop(facet, value); }).join('')}
            </ul>
          </form>
        </div>
      </li>
    `;
  };

  templates.activeFilterPill = function(facet, value) {
    return `
      <li class="product-filters-drawer_activeFacet">
        <button class="product-filters__activeFacetRemove" data-product-filters-el="remove-facet" data-facet="${value.id}" data-facet-field="${facet.id}">
          <span>${value.label}</span>
          ${templates.closeIcon()}
        </button>
      </li>
    `;
  };

  templates.clearAllButton = function() {
    return `
      <li class="product-filters-desktop__listitem">
        <button class="product-filters__clear-all" type="button" data-product-filters-el="clear-all">
          ${translations.clearAll}
          ${templates.closeIconLarge()}
        </button>
      </li>
    `;
  };

  /* ==========================================================================
     Sort By Templates
     ========================================================================== */

  templates.sortItemMobile = function(value) {
    return `
      <li class="product-filters__facetItem">
        <label class="product-filters__facet" data-filter-search-el="facet" data-facet="${value.order}">
          <input type="radio" name="sort" value="${value.id}" ${value.selected ? 'checked' : ''} />
          <div class="product-filters__facetCustomIcon">
            ${templates.checkmarkIcon()}
          </div>
          ${value.label}
        </label>
      </li>
    `;
  };

  templates.sortItemDesktop = function(value) {
    return `
      <li class="product-filters__facetItem">
        <label class="product-filters__facet">
          <input type="radio" name="sort" value="${value.id}" ${value.selected ? 'checked' : ''} />
          <div class="product-filters__facetCustomIcon">
            ${templates.checkmarkIcon()}
          </div>
          <span>${value.label}</span>
        </label>
      </li>
    `;
  };

  templates.mobileSortBy = function(sortOptions, isOpen, selectedLabel) {
    return `
      <details class="product-filters__details" ${isOpen ? 'open' : ''}>
        <summary class="product-filters__summary">
          <h3>${translations.sortBy}: ${selectedLabel}</h3>
          ${templates.chevronDownIcon()}
        </summary>
          <form data-product-filters-el="form" name="sort" data-form-type="sort">
            <ul class="product-filters__facetList">
              ${sortOptions.map((value) => templates.sortItemMobile(value)).join('')}
            </ul>
          </form>
      </details>
    `;
  };

  templates.desktopSortBy = function(sortOptions, selectedLabel) {
    return `
      <li class="product-filters-desktop__listitem">
        <button class="product-filters__trigger" data-product-filters-el="dropdown-trigger" aria-expanded="false" aria-haspopup="listbox" aria-controls="sortOptionDrawer" id="filter-sort">
          ${translations.sortBy}: ${selectedLabel}
          ${templates.chevronDownIcon()}
        </button>

        <div class="product-filters-desktop_dropdown" data-product-filters-el="dropdown" aria-labelledby="filter-sort" id="sortOptionDrawer">
          <form data-product-filters-el="form" name="sort" data-form-type="sort">
            <ul class="product-filters__facetList" role="radiogroup" aria-label="Sort by">
              ${sortOptions.map((value) => templates.sortItemDesktop(value)).join('')}
            </ul>
          </form>
        </div>
      </li>
    `;
  };

})(window.theme.tagalys.templates);
